(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-hm0728-details"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initializeGuide(root) {
    const roomLink = root.querySelector('[data-hm07-open-room]');
    const purchaseArea = roomLink && document.getElementById(roomLink.hash.slice(1));
    const delivery = purchaseArea && purchaseArea.querySelector('.ra-delivery-dates__text');
    if (delivery) {
      const title = delivery.querySelector('strong');
      const note = delivery.querySelector('small');
      if (title && title.textContent !== 'Estimated delivery: 10–20 business days') title.textContent = 'Estimated delivery: 10–20 business days';
      if (note && note.textContent !== 'Hand-painted to order · Free express shipping') note.textContent = 'Hand-painted to order · Free express shipping';
    }
    root.querySelectorAll('[data-hm07-open-room]').forEach(link => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      link.addEventListener('click', event => {
        const productSection = document.getElementById(link.hash.slice(1));
        const launcher = productSection && productSection.querySelector('button.seeonwall-btn');
        if (!launcher || launcher.disabled || !launcher.getClientRects().length) return;
        event.preventDefault();
        launcher.click();
      });
    });
  }
  let frame = 0;
  function refreshGuides() {
    frame = 0;
    const header = document.getElementById('SiteHeader');
    const offset = header ? Math.max(0, Math.min(240, header.getBoundingClientRect().bottom)) : 0;
    document.querySelectorAll('[data-hm07-guide]').forEach(root => {
      initializeGuide(root);
      root.style.setProperty('--hm07-header', Math.round(offset) + 'px');
    });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(refreshGuides); }
  document.addEventListener('DOMContentLoaded', refreshGuides, { once: true });
  document.addEventListener('shopify:section:load', refreshGuides);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  refreshGuides();
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-tp1419-details-v2"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initializeGuide(root) {
    const roomLink = root.querySelector('[data-tp14-open-room]');
    const purchaseArea = roomLink && document.getElementById(roomLink.hash.slice(1));
    const delivery = purchaseArea && purchaseArea.querySelector('.ra-delivery-dates__text');
    if (delivery) {
      const title = delivery.querySelector('strong');
      const note = delivery.querySelector('small');
      if (title && title.textContent !== 'Estimated delivery: 10–20 business days') title.textContent = 'Estimated delivery: 10–20 business days';
      if (note && note.textContent !== 'Hand-painted to order · Free express shipping') note.textContent = 'Hand-painted to order · Free express shipping';
    }
    root.querySelectorAll('[data-tp14-open-room]').forEach(link => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      link.addEventListener('click', event => {
        const productSection = document.getElementById(link.hash.slice(1));
        const launcher = productSection && productSection.querySelector('button.seeonwall-btn');
        if (!launcher || launcher.disabled || !launcher.getClientRects().length) return;
        event.preventDefault();
        launcher.click();
      });
    });
  }
  let frame = 0;
  function refreshGuides() {
    frame = 0;
    const header = document.getElementById('SiteHeader');
    const offset = header ? Math.max(0, Math.min(240, header.getBoundingClientRect().bottom)) : 0;
    document.querySelectorAll('[data-tp14-guide]').forEach(root => {
      initializeGuide(root);
      root.style.setProperty('--tp14-header', Math.round(offset) + 'px');
    });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(refreshGuides); }
  document.addEventListener('DOMContentLoaded', refreshGuides, { once: true });
  document.addEventListener('shopify:section:load', refreshGuides);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  refreshGuides();
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-video-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ra-video-gallery')) {
    customElements.define('ra-video-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.home = this.closest('.shopify-section');
        this.placeInProductInfo();
        document.addEventListener('DOMContentLoaded', () => this.placeInProductInfo(), { ...options, once:true });
        // Return to the owning section before the theme editor replaces markup.
        document.addEventListener('shopify:section:unload', event => {
          if (this.home?.isConnected && (event.target === this.home || event.target.contains(this))) {
            this.home.append(this);
          }
        }, options);
        document.addEventListener('shopify:section:load', () => this.placeInProductInfo(), options);
        document.addEventListener('shopify:section:select', event => {
          if (event.target === this.home) this.scrollIntoView({ block:'center' });
        }, options);
        this.track = this.querySelector('.ra-vg-track');
        this.cards = [...this.querySelectorAll('[data-ra-video]')];
        this.dialog = this.querySelector('dialog');
        this.stage = this.querySelector('.ra-vg-stage');
        this.prev = this.querySelector('.ra-vg-prev');
        this.next = this.querySelector('.ra-vg-next');
        this.cards.forEach((card, index) => card.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.returnFocus = card;
          this.play(index);
          this.dialog.showModal();
          document.documentElement.classList.add('ra-vg-open');
        }, options));
        this.prev.addEventListener('click', () => this.slide(-1), options);
        this.next.addEventListener('click', () => this.slide(1), options);
        this.track.addEventListener('scroll', () => this.updateArrows(), { ...options, passive:true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault(); this.slide(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.querySelector('.ra-vg-close').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, options);
        this.dialog.addEventListener('close', () => {
          this.stage.querySelector('video')?.pause();
          this.stage.replaceChildren();
          document.documentElement.classList.remove('ra-vg-open');
          this.returnFocus?.focus({ preventScroll:true });
        }, options);
        this.querySelector('.ra-vg-modal-prev').addEventListener('click', () => this.play(this.index - 1), options);
        this.querySelector('.ra-vg-modal-next').addEventListener('click', () => this.play(this.index + 1), options);
        const share = this.querySelector('.ra-vg-native-share');
        if (navigator.share) {
          share.hidden = false;
          share.addEventListener('click', async () => {
            try { await navigator.share({ title:this.dataset.shareTitle, url:this.dataset.shareUrl }); }
            catch (error) { if (error.name !== 'AbortError') this.querySelector('.ra-vg-status').textContent = 'Use a social icon or copy the link.'; }
          }, options);
        }
        this.querySelector('.ra-vg-copy').addEventListener('click', async () => {
          try { await navigator.clipboard.writeText(this.dataset.shareUrl); this.querySelector('.ra-vg-status').textContent = 'Link copied'; }
          catch { this.querySelector('.ra-vg-status').textContent = 'Please copy the page address.'; }
        }, options);
        this.observer = new ResizeObserver(() => this.updateArrows());
        this.observer.observe(this.track);
        this.updateArrows();
      }
      placeInProductInfo() {
        const section = document.querySelector('[id^="ProductSection-"][id$="-' + this.dataset.productId + '"]');
        const meta = section?.querySelector('.product-single__meta');
        const hotReload = [...document.querySelectorAll('#MainContent product-hot-reload')]
          .find(element => element.dataset.productUrl === this.dataset.productUrl);
        const target = meta?.querySelector('.ra-product-details') || meta || hotReload?.querySelector('product-form');
        if (!target) {
          if (document.querySelector('#MainContent product-hot-reload')) this.hidden = true;
          return;
        }
        this.hidden = false;
        const anchor = target.querySelector('#ra-product-reviews') || target.querySelector(':scope > details:last-of-type');
        this.dataset.position = 'product-info';
        if (anchor && anchor.nextElementSibling !== this) anchor.after(this);
        else if (!anchor && this.parentElement !== target) target.append(this);
      }
      slide(direction) {
        const step = this.track.querySelector('.ra-vg-card').getBoundingClientRect().width + 14;
        this.track.scrollBy({ left:direction * step, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      updateArrows() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.prev.hidden = this.next.hidden = max < 2;
        this.prev.disabled = this.track.scrollLeft < 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      }
      play(index) {
        if (index < 0 || index >= this.cards.length) return;
        const card = this.cards[index];
        if (card.dataset.type !== 'file' && !/^[A-Za-z0-9_-]{11}$/.test(card.dataset.raVideo)) return;
        this.index = index;
        const dimensions = card.dataset.ratio.split('/').map(Number);
        const ratio = (dimensions.length === 2 ? dimensions[0] / dimensions[1] : dimensions[0]) || 9/16;
        this.stage.style.setProperty('--ra-vg-ratio', ratio);
        this.stage.classList.toggle('ra-vg-portrait', ratio < 1);
        this.stage.querySelector('video')?.pause();
        let player;
        if (card.dataset.type === 'file') {
          player = card.closest('.ra-vg-card').querySelector('template').content.firstElementChild.cloneNode(true);
          player.autoplay = true;
          player.controls = true;
          player.playsInline = true;
        } else {
          player = document.createElement('iframe');
          player.src = 'https://www.youtube.com/embed/' + card.dataset.raVideo + '?autoplay=1&playsinline=1&rel=0';
          player.title = card.dataset.title;
          player.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          player.allowFullscreen = true;
          player.referrerPolicy = 'strict-origin-when-cross-origin';
        }
        this.stage.replaceChildren(player);
        if (card.dataset.type === 'file') player.play().catch(() => {});
        const artwork = this.querySelector('.ra-vg-artwork');
        artwork.href = card.dataset.productUrl;
        artwork.textContent = 'View artwork';
        artwork.setAttribute('aria-label', 'View ' + card.dataset.title);
        this.querySelector('.ra-vg-modal-prev').disabled = index === 0;
        this.querySelector('.ra-vg-modal-next').disabled = index === this.cards.length - 1;
      }
      disconnectedCallback() {
        this.stage?.querySelector('video')?.pause();
        queueMicrotask(() => {
          if (this.isConnected) return;
          if (this.home?.isConnected) {
            this.home.append(this);
            this.placeInProductInfo();
            return;
          }
          this.observer?.disconnect(); this.controller?.abort();
          document.documentElement.classList.remove('ra-vg-open'); this.ready = false;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosemary-campaign-countdown"]) return;
  try {
    
(() => {
  function initializeCampaignClocks() {
    document.querySelectorAll('[data-ra-campaign-countdown]').forEach(bar => {
      if (bar.dataset.raClockReady) return;
      bar.dataset.raClockReady = 'true';
      const starts = Number(bar.dataset.start) * 1000;
      const ends = Number(bar.dataset.end) * 1000;
      const phase = bar.querySelector('[data-ra-phase]');
      const fields = ['days', 'hours', 'minutes', 'seconds'].map(name => bar.querySelector('[data-ra-' + name + ']'));
      let interval;
      const update = () => {
        const now = Date.now();
        if (now >= ends) {
          bar.hidden = true;
          clearInterval(interval);
          return;
        }
        const beforeStart = now < starts;
        const label = beforeStart ? bar.dataset.startsLabel : bar.dataset.endsLabel;
        if (phase.textContent !== label) phase.textContent = label;
        let remaining = Math.max(0, Math.floor(((beforeStart ? starts : ends) - now) / 1000));
        const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
        // Unchanged text still produces DOM mutations and wakes app observers.
        fields.forEach((field, index) => {
          const value = String(values[index]).padStart(2, '0');
          if (field.textContent !== value) field.textContent = value;
        });
      };
      update();
      if (!bar.hidden) {
        interval = setInterval(() => {
          if (!bar.isConnected) clearInterval(interval);
          else if (!document.hidden) update();
        }, 1000);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCampaignClocks, { once: true });
  else initializeCampaignClocks();
  document.addEventListener('shopify:section:load', initializeCampaignClocks);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
